export default __webpack_public_path__ + "static/blog-02-500x338-810860401966327c18491ed26b012967.jpg";